module.exports = __webpack_public_path__ + "static/media/Aeneas.d0106d44.jpg";